{
  "version": 1,
  "asset_id": "12abcf62-dbcb-4797-9bdd-f72bfe577327",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/12abcf62-dbcb-4797-9bdd-f72bfe577327/home-1024.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/12abcf62-dbcb-4797-9bdd-f72bfe577327/home-1024.avif",
  "original_filename": "home-1024.avif",
  "size": 38660,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:28Z"
}
